module.exports = "/_next/static/images/e88ea927b8b9a6e6bdddca0f261c2eea-open-graph-experiment.jpg.webp";